import * as React from "react";
import { RichTextInput } from "ra-input-rich-text";
import { BooleanInput } from "react-admin";
import {
  Edit,
  SimpleForm,
  TextInput,
  EditProps,
  useEditController,
  useRecordContext,
} from "react-admin";
import { Box, Card, CardMedia } from "@mui/material";
import { validateOptionalUrl } from "../../../constants";

const EditPostTitle = () => {
  const record = useRecordContext();
  if (!record) return <>Editando publicación</>;
  return <>Editando: {record.title}</>;
};

export const EditPost: React.FC<EditProps> = (props) => {
  const { record } = useEditController();

  const [previewImage, setPreviewImage] = React.useState<string | null>(null);
  const handleImageChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setPreviewImage(event.target.value);
    },
    []
  );
  React.useEffect(() => {
    if (record?.previewImage) {
      setPreviewImage(record?.previewImage);
    }
  }, [record]);

  const { categories, ...filteredRecord } = record || {}; // Exclude categories field

  return (
    <Edit {...props} title={<EditPostTitle />} mutationMode="pessimistic">
      <SimpleForm record={filteredRecord}>
        <TextInput source="title" label="Título" fullWidth />
        <TextInput source="slug" disabled fullWidth />

        <TextInput
          source="previewImage"
          label="Imagen de portada"
          fullWidth
          onChange={handleImageChange}
          validate={validateOptionalUrl}
        />

        {previewImage && (
          <Card
            sx={{
              margin: "16px auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CardMedia
              component="img"
              alt={`Vista previa de imagen de portada: ${previewImage}`}
              image={previewImage}
              width="100%"
            />
          </Card>
        )}

        <Box sx={{ display: "flex", gap: "16px" }}>
          <BooleanInput source="isPublished" label="Publicado" />
          <BooleanInput source="isHighlighted" label="Destacado" />
        </Box>
        <RichTextInput source="content" fullWidth label="Contenido" />
      </SimpleForm>
    </Edit>
  );
};
